import React from "react";
import AdminAuthLayout from "../../../../Layout/AdminAuthLayout";
import RoleCard from "./RoleCard";

const AddRole = () => {
    return (
        <>
            <AdminAuthLayout>
                <div className="container-fluid py-4">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header pb-0">
                                    <div className="d-flex align-items-center">
                                        <h5 className="mb-0">Add Role</h5>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <p className="text-uppercase text-sm">Add Role Details</p>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group mb-0">
                                                <label
                                                    for="example-text-input"
                                                    className="form-control-label"
                                                >
                                                    Role Name
                                                </label>
                                                <input className="form-control" type="text" value="" />
                                            </div>
                                        </div>
                                    </div>
                                    <hr className="horizontal dark"></hr>
                                    <div className="row">
                                        <RoleCard />
                                        <RoleCard />
                                        <RoleCard />
                                        <RoleCard />
                                        <RoleCard />
                                        <RoleCard />
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col-12 text-end">
                                            <button
                                                type="button"
                                                className="btn bg-gradient-primary me-3 mb-0"
                                            >
                                                Save
                                            </button>
                                            <button type="button" className="btn bg-gradient-danger mb-0">
                                                Clear
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </AdminAuthLayout>
        </>
    );
};

export default AddRole;
